export const projects = [
    {
      title: "BDS Quality Services",
      subtitle: "React",
      description:
        "Built using the React.js, JavaScript, and HTML/CSS, BDS Quality Services is a company that provides quality assurance training and compliance.",
      image: "./bdsqs.jpg",
      link: "https://bdsqs.net",
    },
    {
      title: "The Penalty Box",
      subtitle: "Python and Django",
      description:
        "Personal Blog with full CRUD built using the Django Framework and Python. Users can sign up leave comments on blog posts.",
      image: "./pirate.png",
      link: "https://github.com/michaelbryanstark/penalty-box",
    },
    {
      title: "CodeShare",
      subtitle: "React",
      description:
        "Full stack React app built for developers to share code. Features full CRUD built using JavaScript, Node.js, CSS, MongoDB/Mongoose, JWT-based Authentication.",
      image: "./codeshare.jpg",
      link: "https://github.com/michaelbryanstark/codeShare",
    },
  ];
  export const skills = [
    {
      skill: "JavaScript, TypeScript",
    },
    {
      skill: "Python",
    },
    {
      skill: "Java",
    },
    {
      skill: "React Native",
    },
    {
      skill: "Objective C++",
    },
    {
      skill: "MongoDB and Supabase",
    },
    {
      skill: "Expo",
    },
    {
      skill: "Django",
    },
    {
      skill: "HTML & CSS",
    },
    {
      skill: "Express.js",
    },
    {
      skill: "PostgreSQL & SQL",
    },
    {
      skill: "Node.js",
    },
    {
      skill: "jQuery, JSON, JWT",
    },
    {
      skill: "MERN Stack, MVP Frameworks, RESTful APIs, and more",
    },
  ];